import { createApi } from "@reduxjs/toolkit/query/react";
import { apiFunction } from "../utils";
import { baseQueryWithReauth } from "../baseQueryWithReauth";
import { serializeArgsWithoutToken } from "../serializeQueryArgs";

const dealerBillsApi = createApi({
  reducerPath: "dealerBills",
  baseQuery: baseQueryWithReauth,
  serializeQueryArgs: serializeArgsWithoutToken, // #142: token önbellek anahtarına girmez
  tagTypes: ["Bills"],
  keepUnusedDataFor: 120,
  endpoints(builder) {
    return {
      getDealerRolesBills: builder.query({
        query: (data) => apiFunction(data, `/api/bills/dealerRoles/getMyBills`, "POST"),
        providesTags: ["Bills"],
      }),
    };
  },
});

export const {
  useGetDealerRolesBillsQuery,
  useLazyGetDealerRolesBillsQuery,
} = dealerBillsApi;
export { dealerBillsApi };
